
export const PAYS_ASIE = [
  { code: 'AF', nom: 'Afghanistan', capitale: 'Kaboul', drapeau: '🇦🇫' },
  { code: 'SA', nom: 'Arabie saoudite', capitale: 'Riyad', drapeau: '🇸🇦' },
  { code: 'AM', nom: 'Arménie', capitale: 'Erevan', drapeau: '🇦🇲' },
  { code: 'AZ', nom: 'Azerbaïdjan', capitale: 'Bakou', drapeau: '🇦🇿' },
  { code: 'BH', nom: 'Bahreïn', capitale: 'Manama', drapeau: '🇧🇭' },
  { code: 'BD', nom: 'Bangladesh', capitale: 'Dacca', drapeau: '🇧🇩' },
  { code: 'BT', nom: 'Bhoutan', capitale: 'Thimphou', drapeau: '🇧🇹' },
  { code: 'BN', nom: 'Brunei', capitale: 'Bandar Seri Begawan', drapeau: '🇧🇳' },
  { code: 'KH', nom: 'Cambodge', capitale: 'Phnom Penh', drapeau: '🇰🇭' },
  { code: 'CN', nom: 'Chine', capitale: 'Pékin', drapeau: '🇨🇳' },
  { code: 'CY', nom: 'Chypre', capitale: 'Nicosie', drapeau: '🇨🇾' },
  { code: 'KP', nom: 'Corée du Nord', capitale: 'Pyongyang', drapeau: '🇰🇵' },
  { code: 'KR', nom: 'Corée du Sud', capitale: 'Séoul', drapeau: '🇰🇷' },
  { code: 'AE', nom: 'Émirats arabes unis', capitale: 'Abou Dabi', drapeau: '🇦🇪' },
  { code: 'GE', nom: 'Géorgie', capitale: 'Tbilissi', drapeau: '🇬🇪' },
  { code: 'IN', nom: 'Inde', capitale: 'New Delhi', drapeau: '🇮🇳' },
  { code: 'ID', nom: 'Indonésie', capitale: 'Jakarta', drapeau: '🇮🇩' },
  { code: 'IQ', nom: 'Irak', capitale: 'Bagdad', drapeau: '🇮🇶' },
  { code: 'IR', nom: 'Iran', capitale: 'Téhéran', drapeau: '🇮🇷' },
  { code: 'IL', nom: 'Israël', capitale: 'Jérusalem', drapeau: '🇮🇱' },
  { code: 'JP', nom: 'Japon', capitale: 'Tokyo', drapeau: '🇯🇵' },
  { code: 'JO', nom: 'Jordanie', capitale: 'Amman', drapeau: '🇯🇴' },
  { code: 'KZ', nom: 'Kazakhstan', capitale: 'Noursoultan', drapeau: '🇰🇿' },
  { code: 'KG', nom: 'Kirghizistan', capitale: 'Bichkek', drapeau: '🇰🇬' },
  { code: 'KW', nom: 'Koweït', capitale: 'Koweït', drapeau: '🇰🇼' },
  { code: 'LA', nom: 'Laos', capitale: 'Vientiane', drapeau: '🇱🇦' },
  { code: 'LB', nom: 'Liban', capitale: 'Beyrouth', drapeau: '🇱🇧' },
  { code: 'MY', nom: 'Malaisie', capitale: 'Kuala Lumpur', drapeau: '🇲🇾' },
  { code: 'MV', nom: 'Maldives', capitale: 'Malé', drapeau: '🇲🇻' },
  { code: 'MN', nom: 'Mongolie', capitale: 'Oulan-Bator', drapeau: '🇲🇳' },
  { code: 'MM', nom: 'Myanmar (Birmanie)', capitale: 'Naypyidaw', drapeau: '🇲🇲' },
  { code: 'NP', nom: 'Népal', capitale: 'Katmandou', drapeau: '🇳🇵' },
  { code: 'OM', nom: 'Oman', capitale: 'Mascate', drapeau: '🇴🇲' },
  { code: 'UZ', nom: 'Ouzbékistan', capitale: 'Tachkent', drapeau: '🇺🇿' },
  { code: 'PK', nom: 'Pakistan', capitale: 'Islamabad', drapeau: '🇵🇰' },
  { code: 'PS', nom: 'Palestine', capitale: 'Ramallah', drapeau: '🇵🇸' },
  { code: 'PH', nom: 'Philippines', capitale: 'Manille', drapeau: '🇵🇭' },
  { code: 'QA', nom: 'Qatar', capitale: 'Doha', drapeau: '🇶🇦' },
  { code: 'SG', nom: 'Singapour', capitale: 'Singapour', drapeau: '🇸🇬' },
  { code: 'LK', nom: 'Sri Lanka', capitale: 'Sri Jayawardenepura Kotte', drapeau: '🇱🇰' },
  { code: 'SY', nom: 'Syrie', capitale: 'Damas', drapeau: '🇸🇾' },
  { code: 'TJ', nom: 'Tadjikistan', capitale: 'Douchanbé', drapeau: '🇹🇯' },
  { code: 'TW', nom: 'Taïwan', capitale: 'Taipei', drapeau: '🇹🇼' },
  { code: 'TH', nom: 'Thaïlande', capitale: 'Bangkok', drapeau: '🇹🇭' },
  { code: 'TL', nom: 'Timor oriental', capitale: 'Dili', drapeau: '🇹🇱' },
  { code: 'TR', nom: 'Turquie', capitale: 'Ankara', drapeau: '🇹🇷' },
  { code: 'TM', nom: 'Turkménistan', capitale: 'Achgabat', drapeau: '🇹🇲' },
  { code: 'VN', nom: 'Viêt Nam', capitale: 'Hanoï', drapeau: '🇻🇳' },
  { code: 'YE', nom: 'Yémen', capitale: 'Sanaa', drapeau: '🇾🇪' }
];
